import * as Yup from 'yup'

export const HomeownerSchema = Yup.object().shape({

    first_name: Yup
        .string()
        .label('First Name')
        .min(1)
        .required()
        .nullable(),

    last_name: Yup
        .string()
        .label('Last Name')
        .nullable(),

    phone_number: Yup
        .string()
        .label('Phone Number')
        .nullable(),

    secondary_phone_number: Yup
        .string()
        .label('Secondary Phone Number')
        .nullable(),
        
    email_address: Yup
        .string()
        .email()
        .label("Email Address")
        .nullable(),

    mailing_address: Yup
        .string()
        .label('Address')
        .nullable(),

    city: Yup
        .string()
        .label('City')
        .nullable(),

    state: Yup
        .string()
        .label('State')
        .max(2)
        .nullable(),

    zip_code: Yup
        .string()
        .label('Zip Code')
        .max(10)
        .min(5)
        .nullable(),

    fax_number: Yup
        .string()
        .label('Fax Number')
        .nullable(),

    note: Yup
        .string()
        .label('Notes')
        .nullable(),
})
